// dateUtils.js
import dayjs from "../../../utils/dayjs"; // Usar dayjs configurado con timezone

// Función para ajustar la fecha según la zona horaria (ya no necesaria con dayjs configurado)
export const ajustarFecha = (fecha) => {
  return dayjs(fecha).toDate(); // dayjs ya maneja la timezone correctamente
};

// Función para obtener el rango de una semana (con inicio en lunes)
export const getWeekRange = (weeksAgo = 0) => {
  const start = dayjs().subtract(weeksAgo, 'week').startOf('week').add(1, 'day'); // Lunes
  const end = dayjs().subtract(weeksAgo, 'week').endOf('week').add(1, 'day'); // Domingo

  return { start: start.toDate(), end: end.toDate() };
};

// Función para obtener el rango de un mes (actual o anterior)
export const getMonthRange = (monthsAgo = 0) => {
  const start = dayjs().subtract(monthsAgo, 'month').startOf('month');
  const end = dayjs().subtract(monthsAgo, 'month').endOf('month');

  return { start: start.toDate(), end: end.toDate() };
};
